module.exports = __webpack_public_path__ + "static/media/fbIcon.410ccac0.svg";